import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { distinctUntilChanged } from 'rxjs/operators';
import { Component, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import { generateColumns } from '../../../../../common/functions/column-functions';
interface IColumnProduct {
    text?: Array<string>;
    code?: number;
    region?: string;
    tax?: string;
    prefixText: string;
    value?: string;
    button?: Object;
}

interface IResultTableColumns {
    columns: Array<IColumnProduct>;
}

export interface IResultTable {
    header: Array<string>;
    body: Array<IResultTableColumns>;
}

@Component({
    selector: 'app-results',
    templateUrl: 'results.component.html',
    styleUrls: ['./results.component.scss']
})

export class ResultsComponent implements OnInit {
    @Input() data: any;
    readonly breakpoint$ = this.breakpointObserver
        .observe(['(min-width: 760px)'])
        .pipe(distinctUntilChanged());
    public showAlertMessage = false;
    public linkType = '';
    public dataResult: IResultTable = {
        header: [
            'Descripción del producto',
            'N° Orden',
            'Total a Pagar',
            'Método de pago'
        ],
        body: []
    }

    ngOnInit(): void {
        if (this.data.show) {
            if (this.data.status === 'found') {
                [this.data, this.linkType, this.dataResult] = generateColumns(this.data, this.linkType, this.dataResult);
            }
            if (this.data.status === 'Found finished') {
                this.showAlertMessage = true;
            }
        }
    }


    public navigateTo(url: string): void {
        if (isPlatformBrowser(this.platformId)) {
            window.open(url, '_blank');
        }
    }

    constructor(
        @Inject(PLATFORM_ID) private readonly platformId: object,
        private readonly breakpointObserver: BreakpointObserver
    ) { }
}
